<!-- Rail -->
<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    @if (rail.searchQuery.journeyType === IrlJourneyType.SingleJourney) {
      @if (rail?.detail; as detail) {
        <div [class.duplicate-item-wrapper]="duplicateBooking">
          @if (duplicateBooking) {
            <div class="duplicate-item-date">
              <i class="ico-rail"></i>&nbsp;
              @if (detail?.outwardDetail?.departureDateTime; as departureDateTime) {
                <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                <strong>{{ departureDateTime | sabsDate: 1 }}</strong>
              }
            </div>
          }
          <div [class.duplicate-item-info]="duplicateBooking">
            <div class="cart_item_heading">
              @if (!duplicateBooking) {
                <i class="ico-rail"></i>&nbsp;
              }
              <span
                >{{ detail.outwardDetail.departureStationName }} to
                {{ detail.outwardDetail.arrivalStationName }}</span
              >
              @if (!duplicateBooking) {
                <section (mouseleave)="tt1.close()">
                  <button
                    class="cart_item_remove ico-trash"
                    ngbTooltip="Remove {{ detail.outwardDetail.departureStationName }} to {{
                      detail.outwardDetail.arrivalStationName
                    }} from your {{ displayItinerary ? 'itinerary' : 'basket' }}"
                    attr.aria-label="Remove {{ detail.outwardDetail.departureStationName }} to {{
                      detail.outwardDetail.arrivalStationName
                    }} rail from your {{ displayItinerary ? 'itinerary' : 'basket' }}"
                    i18n-ngbTooltip
                    (click)="remove.emit()"
                    triggers="manual"
                    #tt1="ngbTooltip"
                    (mouseenter)="tt1.open()"
                    (focus)="tt1.open()"
                    (blur)="tt1.close()"
                    id="remove-basketitem-{{ rail.id }}-0"
                  ></button>
                </section>
              }
              @if (!duplicateBooking) {
                <section (mouseleave)="tt2.close()">
                  <img
                    src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                      displayItinerary ? 'luggage_icon' : 'basket_move'
                    }}.svg"
                    ngbTooltip="Move to different {{
                      (displayItinerary ? 'itinerary' : 'basket') | translate
                    }}"
                    i18n-ngbTooltip
                    class="move_basket_icon"
                    role="button"
                    attr.aria-label="Move {{ detail.outwardDetail.departureStationName }} to {{
                      detail.outwardDetail.arrivalStationName
                    }} rail to different {{ displayItinerary ? 'itinerary' : 'basket' }}"
                    (click)="openChangeModal.emit()"
                    (keydown.enter)="openChangeModal.emit()"
                    (keydown.space)="openChangeModal.emit()"
                    triggers="manual"
                    #tt2="ngbTooltip"
                    (mouseenter)="tt2.open()"
                    (focus)="tt2.open()"
                    (blur)="tt2.close()"
                    tabindex="0"
                    id="share-basketitem-{{ rail.id }}-0"
                  />
                </section>
              }
            </div>
            @if (detail?.outwardDetail?.supplierTickets[0]; as supplierTicket) {
              @if (supplierTicket?.legs; as legs) {
                <div class="cart_item_operator">
                  <span i18n="@@basketPanelOperatorRail">Operator:</span>
                  <strong>{{ legs[0].operator }}</strong>
                </div>
              }
              @if (supplierTicket?.ticketDescription; as ticketDescription) {
                <div class="cart_item_rail_ticket_name">
                  <strong>{{ ticketDescription }}</strong>
                </div>
              }
            }
            @if (
              !duplicateBooking && detail?.outwardDetail?.departureDateTime;
              as departureDateTime
            ) {
              <div class="cart_item_rail_ticket_times">
                @if (!duplicateBooking) {
                  <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                  <strong>{{ departureDateTime | standardDate }}</strong>
                }
                @if (duplicateBooking) {
                  <span>{{ departureDateTime | date: 'HH:mm' }}</span>
                }
              </div>
            }
            <div class="car_cart_item_to_point"></div>
            @if (!duplicateBooking) {
              @for (user of travellers; track user) {
                <div class="traveller-name">
                  <b>{{ user.forename }}, {{ user.surname }}</b>
                </div>
              }
            }
            <div class="cart_item_price">
              @if (duplicateBooking) {
                <strong i18n="@@basketPanelCostRail">Cost</strong>
              }
              <strong>{{ rail.price | currency: rail.currency }}</strong>
              @if (!duplicateBooking) {
                <em>
                  <span i18n="@@basketPanelTotalPriceRail">&nbsp;Total Price</span>
                  @if (rail?.adults > 1) {
                    <span>(For {{ rail.adults }} travellers)</span>
                  }
                </em>
              }
            </div>
          </div>
        </div>
      }
    }

    @if (rail.searchQuery.journeyType === 'ReturnJourney') {
      @if (rail?.detail; as detail) {
        <div>
          <div [class.duplicate-item-wrapper]="duplicateBooking">
            @if (duplicateBooking) {
              <div class="duplicate-item-date">
                <i class="ico-rail"></i>&nbsp;
                @if (detail?.outwardDetail?.departureDateTime; as departureDateTime) {
                  <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                  <strong>{{ departureDateTime | sabsDate: 1 }}</strong>
                }
              </div>
            }
            <div [class.duplicate-item-info]="duplicateBooking">
              @if (detail.outwardDetail; as outwardDetail) {
                <div class="cart_item_heading">
                  @if (!duplicateBooking) {
                    <i class="ico-rail"></i>&nbsp;
                  }
                  <span
                    >{{ outwardDetail.departureStationName }} to
                    {{ outwardDetail.arrivalStationName }}</span
                  >
                  @if (!duplicateBooking) {
                    <button
                      class="cart_item_remove ico-trash"
                      i18n-title
                      attr.title="Remove {{ outwardDetail.departureStationName }} to {{
                        outwardDetail.arrivalStationName
                      }} rail from your {{ displayItinerary ? 'itinerary' : 'basket' }}"
                      attr.aria-label="Move {{ outwardDetail.departureStationName }} to {{
                        outwardDetail.arrivalStationName
                      }} rail to different {{ displayItinerary ? 'itinerary' : 'basket' }}"
                      (click)="remove.emit()"
                      id="remove-basketitem-{{ rail.id }}-1"
                    ></button>
                  }
                  @if (!duplicateBooking) {
                    <section (mouseleave)="tt3.close()">
                      <img
                        src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/basket_move.svg"
                        class="move_basket_icon"
                        i18n-ngbTooltip
                        role="button"
                        aria-label="Move to different {{
                          displayItinerary ? 'itinerary' : 'basket'
                        }}"
                        ngbTooltip="Move item to different {{
                          displayItinerary ? 'itinerary' : 'basket'
                        }}"
                        (click)="openChangeModal.emit()"
                        (keydown.enter)="openChangeModal.emit()"
                        (keydown.space)="openChangeModal.emit()"
                        tabindex="0"
                        id="share-basketitem-{{rail.id}-1}"
                        triggers="manual"
                        #tt3="ngbTooltip"
                        (mouseenter)="tt3.open()"
                        (focus)="tt3.open()"
                        (blur)="tt3.close()"
                      />
                    </section>
                  }
                </div>
              }
              @if (detail?.outwardDetail?.supplierTickets[0]; as supplierTicket) {
                @if (supplierTicket?.legs; as legs) {
                  <div class="cart_item_operator">
                    <span i18n="@@basketPanelOperatorRail">Operator:</span>
                    <strong>{{ legs[0].operator }}</strong>
                  </div>
                }
                @if (supplierTicket?.ticketDescription; as ticketDescription) {
                  <div class="cart_item_rail_ticket_name">
                    <strong>{{ ticketDescription }}</strong>
                  </div>
                }
              }
              @if (detail?.outwardDetail?.departureDateTime; as departureDateTime) {
                <div class="cart_item_rail_ticket_times">
                  @if (!duplicateBooking) {
                    <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                    <strong>{{ departureDateTime | standardDate }}</strong>
                  }
                  @if (duplicateBooking) {
                    <span>{{ departureDateTime | date: 'HH:mm' }}</span>
                  }
                </div>
              }
            </div>
          </div>
          @if (!duplicateBooking) {
            <div class="rail_return_container"></div>
          }
          <div [class.duplicate-item-wrapper]="duplicateBooking">
            @if (duplicateBooking && detail.inwardDetail) {
              <div class="duplicate-item-date">
                <i class="ico-rail"></i>&nbsp;
                @if (detail?.inwardDetail?.departureDateTime; as departureDateTime) {
                  <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                  <strong>{{ departureDateTime | sabsDate: 1 }}</strong>
                }
              </div>
            }
            <div [class.duplicate-item-info]="duplicateBooking">
              @if (detail.inwardDetail; as inwardDetail) {
                <div class="cart_item_heading">
                  @if (!duplicateBooking) {
                    <i class="ico-rail"></i>&nbsp;
                  }
                  <span
                    >{{ inwardDetail.departureStationName }} to
                    {{ inwardDetail.arrivalStationName }}</span
                  >
                </div>
              }
              @if (detail?.inwardDetail?.supplierTickets[0]; as supplierTicket) {
                @if (supplierTicket?.legs; as legs) {
                  <div class="cart_item_operator">
                    <span i18n="@@basketPanelOperatorRail">Operator:</span>
                    <strong>{{ legs[0].operator }}</strong>
                  </div>
                }
                @if (supplierTicket?.ticketDescription; as ticketDescription) {
                  <div class="cart_item_rail_ticket_name">
                    <strong>{{ ticketDescription }}</strong>
                  </div>
                }
              }
              @if (detail?.inwardDetail?.departureDateTime; as departureDateTime) {
                <div class="cart_item_rail_ticket_times">
                  @if (!duplicateBooking) {
                    <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                    <strong>{{ departureDateTime | standardDate }}</strong>
                  }
                  @if (duplicateBooking) {
                    <span>{{ departureDateTime | date: 'HH:mm' }}</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="car_cart_item_to_point"></div>
        @if (!duplicateBooking) {
          @for (user of travellers; track user) {
            <div class="traveller-name">
              <b>{{ user.forename }}, {{ user.surname }}</b>
            </div>
          }
        }
        <div class="cart_item_price">
          @if (duplicateBooking) {
            <strong i18n="@@basketPanelCostRail">Cost</strong>
          }
          <strong>{{ rail.price | currency: rail.currency }}</strong>
          @if (!duplicateBooking) {
            <em>
              <span i18n="@@basketPanelTotalPriceRail">&nbsp;Total Price</span>
              @if (rail?.adults > 1) {
                <span>(For {{ rail.adults }} travellers)</span>
              }
            </em>
          }
        </div>
      }
    }
    <!-- TODO: handle OpenReturnJourney case -->
    <!-- TODO: handle DualSingleJourney case -->
  </div>
  @if (!duplicateBooking) {
    <app-irl-journey-details [basketItem]="rail"></app-irl-journey-details>
  }
</div>
